










































import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

import ChevronRightSolid from '~/components/icons/ChevronRightSolid.vue';

@Component({
  components: { ChevronRightSolid },
})
export default class FullScreenGalleryModal extends Vue {
  @Prop(String) image: '';
  @Prop(Array) gallery: string[];
  @Prop(Number) customIndex: 0;

  index: number = 0;
  imageCarousel: string = '';

  /*
    The modal will be closed when user clicks on button
    or by this.onInputKeydown
  */
  @Emit('modal-close')
  closeModal () {
  }

  mounted () {
    // Remove scroll of the page when modal is active
    // We also listen for keydown events to handle user actions on modal
    if (process.client) {
      document.body.classList.add('overflow-y-hidden');
      window.addEventListener('keydown', this.onInputKeydown, false);
    }

    // Modal is initiated to a specific index based on props
    if (this.customIndex) this.index = this.customIndex;
    this.imageCarousel = this.image || this.gallery[0];
  }

  /* Removes the events declared in mounted */
  beforeDestroy () {
    if (process.client) {
      document.body.classList.remove('overflow-y-hidden');
      window.removeEventListener('keydown', this.onInputKeydown);
    }
  }

  /* Image fallback if card <img @error> is triggered */
  imageFallback (event: any) {
    event.target.src = "/img/placeholders/destination-placeholder.png";
  }

  /* Handle pagination on modal */
  dotImage (index: number) {
    if (this.imageCarousel === this.gallery[index]) {
      return '/icons/dot-active.svg';
    }
    return '/icons/dot-inactive.svg';
  }

  /* Will update the active image */
  selectImage (index: number) {
    this.imageCarousel = this.gallery[index];
    this.index = index;
  }

  /* Will go to previous image in this.gallery array */
  prevImg () {
    if (this.index === 0) {
      this.index = this.gallery.length - 1;
    } else {
      this.index--;
    }
    this.imageCarousel = this.gallery[this.index];
  }

  /* Will go to next image in this.gallery array */
  nextImg () {
    if (this.index === this.gallery.length - 1) {
      this.index = 0;
    } else {
      this.index++;
    }
    this.imageCarousel = this.gallery[this.index];
  }

  /* Based on user keyboard events, we can update the modal status */
  onInputKeydown (event: KeyboardEvent) {
    switch (event.key) {
      case 'ArrowLeft':
        return this.prevImg();
      case 'ArrowRight':
        return this.nextImg();
      case 'Escape':
        return this.closeModal();
    }
  }
};
